import { Injectable, isDevMode, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { from } from 'rxjs';
import algoliasearch from 'algoliasearch/lite';

@Injectable()
export class AlgoliaSearchService implements OnInit {
  client = algoliasearch('QFKU05XDDS', '71ff0b45178e0a89c52f599287697419');
  index = isDevMode() ? this.client.initIndex('CorePartsSuggestions_DEV') : this.client.initIndex('CorePartsSuggestions');

  constructor() {}

  ngOnInit(): void {}

  getHits(query: string, indexName?, facets?, filters?): Observable<any> {
    if (indexName) {
      this.index = this.client.initIndex(indexName);
    }

    return from(this.index.search(query, { facets, filters }));
  }
}